import { render, staticRenderFns } from "./ReviewPay.vue?vue&type=template&id=1cab0b96&scoped=true"
import script from "./ReviewPay.vue?vue&type=script&lang=js"
export * from "./ReviewPay.vue?vue&type=script&lang=js"
import style0 from "./ReviewPay.vue?vue&type=style&index=0&id=1cab0b96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cab0b96",
  null
  
)

export default component.exports